import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var SubmitButton = function SubmitButton() {
  return import('@/components/atoms/SubmitButton');
};
var AssetImage = function AssetImage() {
  return import('@/components/atoms/AssetImage');
};
var PartySlider = function PartySlider() {
  return import('@/components/molecules/PartySlider');
};
import Nl2br from 'vue-nl2br';
var QuestAutoBattle = function QuestAutoBattle() {
  return import('@/components/molecules/QuestAutoBattle');
};
var QuestAutoBattleResult = function QuestAutoBattleResult() {
  return import('@/components/molecules/QuestAutoBattleResult');
};
var QuestAutoBattleReward = function QuestAutoBattleReward() {
  return import('@/components/molecules/QuestAutoBattleReward');
};
var RecoveryStaminaModal = function RecoveryStaminaModal() {
  return import('@/components/organisms/RecoveryStaminaModal');
};
export default {
  components: {
    Modal: Modal,
    PrimeIcon: PrimeIcon,
    SubmitButton: SubmitButton,
    AssetImage: AssetImage,
    PartySlider: PartySlider,
    Nl2br: Nl2br,
    QuestAutoBattle: QuestAutoBattle,
    QuestAutoBattleResult: QuestAutoBattleResult,
    QuestAutoBattleReward: QuestAutoBattleReward,
    RecoveryStaminaModal: RecoveryStaminaModal
  },
  props: {
    node: {
      type: Object,
      default: function _default() {},
      required: true
    },
    prevNodeId: {
      type: Number,
      default: 0,
      required: true
    },
    prevSelectedPartryNo: {
      type: Number,
      default: 0
    },
    isNormalQuest: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      selectedTeam: 0,
      selectedFmTeam: 0,
      questLevel: 0,
      autoCount: 2,
      isSettings: true,
      isBattle: false,
      isResult: false,
      isReward: false,
      currentConsecutiveQuest: {},
      isFetched: false,
      isRepSphereLimtModalShow: false,
      ingotLimit: false,
      isRecoveryStaminaModalShown: false,
      isComplate: false,
      isPrimeErrorModalShown: false,
      orbLimit: false
    };
  },
  computed: {
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    templates: function templates() {
      return useDeckTemplateStore().getDeckTemplates;
    },
    me: function me() {
      return useUserStore().me;
    },
    quest: function quest() {
      return useNodeStore().getQuest;
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    isAutoBattleModalShown: function isAutoBattleModalShown() {
      return !!Object.keys(this.node).length && this.$parent.isQuestAutoBattleModalShown;
    },
    lvs: function lvs() {
      var lvs = this.$util.clone(this.node.nodeLvsList);
      lvs.sort(function (p, c) {
        if (p.lv < c.lv) return -1;
        if (p.lv > c.lv) return 1;
        return 0;
      });
      return lvs;
    },
    selectedNode: function selectedNode() {
      var _this = this;
      var node = this.lvs.find(function (x) {
        return x.nodeId == _this.questLevel;
      });
      if (node) return node;
      return {};
    },
    cannotGo: function cannotGo() {
      return this.isPossibleStamina || this.isPossiblePartyLv || this.isLandQuestMaxCount;
    },
    getLandMaxQuestCount: function getLandMaxQuestCount() {
      return this.selectedNode.maxCnt;
    },
    getLandCurrentQuestCount: function getLandCurrentQuestCount() {
      return this.selectedNode.maxCnt - this.selectedNode.currentCnt;
    },
    isPossibleStamina: function isPossibleStamina() {
      if (!this.isNormalQuest) return false;
      return this.selectedNode.stamina * this.autoCount > useUserStore().getStamina.currentStamina;
    },
    isPossiblePartyLv: function isPossiblePartyLv() {
      return this.partyLv > this.getPartyLv(this.templates[this.selectedTeam]);
    },
    isLandQuestMaxCount: function isLandQuestMaxCount() {
      if (this.isNormalQuest) return false;
      return this.autoCount > this.getLandCurrentQuestCount;
    },
    selectLvIsPrime: function selectLvIsPrime() {
      return this.selectedNode.isPrime;
    },
    partyLv: function partyLv() {
      return this.selectedNode.needPartyLevel;
    },
    autoCountList: function autoCountList() {
      return [{
        id: 2,
        str: this.$i18n.locale == 'ja' ? 2 + '回' : 2
      }, {
        id: 3,
        str: this.$i18n.locale == 'ja' ? 3 + '回' : 3
      }, {
        id: 4,
        str: this.$i18n.locale == 'ja' ? 4 + '回' : 4
      }, {
        id: 5,
        str: this.$i18n.locale == 'ja' ? 5 + '回' : 5
      }, {
        id: 6,
        str: this.$i18n.locale == 'ja' ? 6 + '回' : 6
      }, {
        id: 7,
        str: this.$i18n.locale == 'ja' ? 7 + '回' : 7
      }, {
        id: 8,
        str: this.$i18n.locale == 'ja' ? 8 + '回' : 8
      }, {
        id: 9,
        str: this.$i18n.locale == 'ja' ? 9 + '回' : 9
      }, {
        id: 10,
        str: this.$i18n.locale == 'ja' ? 10 + '回' : 10
      }];
    },
    isUnCloseConsecutiveQuest: function isUnCloseConsecutiveQuest() {
      return !!this.quest && !!this.quest.consecutiveQuestId;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.isSettings = true;
            _this2.isBattle = false;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchMyOwnExtensionIds: function fetchMyOwnExtensionIds() {
      return useExtensionStore().fetchMyOwnExtensionIds();
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    fetchData: function fetchData() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedTeam, selectedFmTeam, questLevel, autoCount;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.questLevel = _this3.lvs[0].nodeId;
              _context2.next = 3;
              return useDeckTemplateStore().fetchDeckTemplates();
            case 3:
              if (!_this3.isUnCloseConsecutiveQuest) {
                _context2.next = 9;
                break;
              }
              _context2.next = 6;
              return _this3.$questsService.getConsecutiveQuest(_this3.quest.consecutiveQuestId);
            case 6:
              _this3.currentConsecutiveQuest = _context2.sent;
              _this3.isSettings = false;
              _this3.isBattle = true;
            case 9:
              selectedTeam = _this3.$localStorage.get('consecutivePartyNo');
              if (selectedTeam) _this3.selectedTeam = Number(selectedTeam);
              selectedFmTeam = _this3.$localStorage.get('consecutiveFmPartyNo');
              if (selectedFmTeam) _this3.selectedFmTeam = Number(selectedFmTeam);
              questLevel = _this3.$localStorage.get('consecutiveLv' + _this3.node.nodeType);
              if (questLevel) _this3.questLevel = Number(questLevel);
              autoCount = _this3.$localStorage.get('consecutiveCount');
              if (autoCount) _this3.autoCount = Number(autoCount);
              _this3.isFetched = true;
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    selectTeamTemplate: function selectTeamTemplate(teamIndex) {
      return this.selectedTeam = teamIndex;
    },
    selectFmTeamTemplate: function selectFmTeamTemplate(teamIndex) {
      return this.selectedFmTeam = teamIndex;
    },
    getPartyLv: function getPartyLv(party) {
      var lv = 0;
      if (party) {
        for (var i = 0; i < party.unitsList.length; i++) {
          var hero = this.getHero(party.unitsList[i].heroId);
          if (party.unitsList[i].asset || party.unitsList[i].heroId < 11000 || party.unitsList[i].heroId >= 12000) {
            lv += this.$constants.PARTY_LV_CALCULATE[hero.rarity];
            lv += Math.floor(hero.lv / 5);
          }
        }
      }
      return lv;
    },
    onClickNext: function onClickNext() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this4.isBattle) {
                _context3.next = 5;
                break;
              }
              _this4.isBattle = false;
              _this4.isResult = true;
              _context3.next = 15;
              break;
            case 5:
              if (!_this4.isResult) {
                _context3.next = 10;
                break;
              }
              _this4.isResult = false;
              _this4.isReward = true;
              _context3.next = 15;
              break;
            case 10:
              _context3.next = 12;
              return _this4.consecutiveClose();
            case 12:
              _this4.isReward = false;
              _this4.isSettings = true;
              _this4.$emit('refetch-node');
              // this.$emit('modal-close')
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    partyEdit: function partyEdit(type) {
      this.savePreveData();
      this.$localStorage.set('consecutivePrev', this.questLevel);
      if (type === 0) {
        this.$router.push(this.localePath({
          path: "/parties",
          query: {
            partyIndex: Number(this.selectedTeam),
            autoQuest: true
          }
        }));
      } else {
        this.$router.push(this.localePath({
          path: "/parties",
          query: {
            partyIndex: Number(this.selectedFmTeam),
            autoQuest: true
          }
        }));
      }
    },
    startConsecutiveQuest: function startConsecutiveQuest() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _this5.savePreveData();
              _context4.next = 4;
              return _this5.$questsService.consecutiveQuest(_this5.questLevel, _this5.selectedTeam, _this5.selectedFmTeam, _this5.autoCount);
            case 4:
              _this5.currentConsecutiveQuest = _context4.sent;
              _context4.next = 7;
              return useUserStore().fetchStamina();
            case 7:
              _this5.isSettings = false;
              _this5.isBattle = true;
              _context4.next = 16;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              console.log(_context4.t0);
              if (_context4.t0.message.includes('replica sphere limit')) {
                _this5.ingotLimit = false;
                _this5.isRepSphereLimtModalShow = true;
              } else if (_context4.t0.message.includes('sphere item limit')) {
                _this5.orbLimit = true;
                _this5.isRepSphereLimtModalShow = true;
              } else if (_context4.t0.message.includes('item limit')) {
                _this5.ingotLimit = true;
                _this5.isRepSphereLimtModalShow = true;
              } else if (_context4.t0.message.includes('only prime')) {
                _this5.isPrimeErrorModalShown = true;
              }
              _this5.$toast.error('Error.');
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 11]]);
      }))();
    },
    consecutiveClose: function consecutiveClose() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var closeData;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return _this6.$questsService.consecutiveClose();
            case 3:
              closeData = _context5.sent;
              _context5.next = 6;
              return useNodeStore().checkUnclosedQuest();
            case 6:
              _this6.$parent.fmCount = closeData.length;
              _this6.isComplate = false;
              _context5.next = 14;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](0);
              console.log(_context5.t0);
              _this6.$toast.error('Error.');
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 10]]);
      }))();
    },
    savePreveData: function savePreveData() {
      this.$localStorage.set('consecutivePartyNo', this.selectedTeam);
      this.$localStorage.set('consecutiveFmPartyNo', this.selectedFmTeam);
      this.$localStorage.set('consecutiveLv' + this.node.nodeType, this.questLevel);
      this.$localStorage.set('consecutiveCount', this.autoCount);
    },
    recoveryStaminaModalOpen: function recoveryStaminaModalOpen() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return useConsumableStore().fetchLimitedMyItems();
            case 2:
              _this7.isRecoveryStaminaModalShown = true;
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    isComplateAction: function isComplateAction() {
      this.isComplate = true;
    },
    primeErrorModalClose: function primeErrorModalClose() {
      location.reload();
    }
  }
};